// RU-STRATLINK SL-4 / SL-12: the short strategy reference shown on positions and on every strategy listing,
// and the copy of the full id behind it.
import { toast } from "sonner";

export const strategyRef = (id) => (id ? String(id).slice(0, 8) : "");

export function copyStrategyId(id) {
  const clip = typeof navigator !== "undefined" ? navigator.clipboard : null;
  if (!clip?.writeText) { toast.error("Copy failed"); return; }
  clip.writeText(String(id)).then(() => toast.success("Strategy id copied"), () => toast.error("Copy failed"));
}

// RU-REFSEARCH RS-1: the one strategy search matcher (Strategy Builder, Regime Suite, paper positions).
// The query is trimmed and lower-cased; the chip's copied text "ref a1b2c3d4" / "REF: a1b2" matches like the bare
// ref (a bare "ref" is not stripped). Name and symbol match as substrings, the id as a prefix (full id, 8-char ref
// or any prefix). `fields` maps the item to its {name, symbol, id} (functions returning strings); empty query = all.
export const normaliseStrategyQuery = (q) => String(q || "").trim().toLowerCase().replace(/^ref[:\s]+/, "");

export function matchesStrategyQuery(item, q, { name, symbol, id } = {}) {
  const n = normaliseStrategyQuery(q);
  if (!n) return true;
  const val = (f) => String((f && f(item)) || "").toLowerCase();
  return val(name).includes(n) || val(symbol).includes(n) || val(id).startsWith(n);
}

// RS-3: the empty-state line for a search that matches nothing.
export function noStrategyMatchText(q) {
  const raw = String(q || "").trim();
  const n = normaliseStrategyQuery(raw);
  const refLike = /^ref[:\s]+/i.test(raw) || /^[0-9a-f-]{4,}$/.test(n);
  return refLike ? `No strategy with ref ${n}` : `No strategy matches "${raw}"`;
}

export const STRATEGY_SEARCH_PLACEHOLDER = "Search name, symbol or ref…";
